<template>
  <div class="template-type__root" :style="rootStyle">
    <div class="template-type__header">
      <div class="label-left">创建应用</div>
      <el-popover
        placement="bottom"
        effect="light"
        :showAfter="250"
        :closeDelay="200"
        :width="136"
        popperClass="help-dr-code-pop"
      >
        <template #reference>
          <div class="design">
            <IconMyIconPersonalDesign class="icon-design"></IconMyIconPersonalDesign>
            <div class="label-design">我要定制</div>
          </div>
        </template>
        <template #default><help-qrcode></help-qrcode></template>
      </el-popover>

      <template-search></template-search>
    </div>
    <div class="template-type__main">
      <template v-if="!isDataInit">
        <template-type-skeleton></template-type-skeleton>
      </template>
      <template v-else>
        <template-type-list v-if="typeList.length" :typeList="typeList"></template-type-list>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { openInNewTab } from '@/utils/open-in-new-tab';
import { RespCategory } from '@vas2t-lowcode/api';
import { useZIndex } from 'element-plus';
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import templateSearch from './template-search.vue';
import { dwOnDesignClick } from './template-type-dw';
import { reqTemplateTypeDataAsync, resetTemplateTypeDataAsync } from './template-type-interface';
import templateTypeList from './template-type-list.vue';
const HelpQrcode = defineAsyncComponent(() => import('@/features/help-icon/help-qrcode.vue'));

/** 数据加载状态 */
const isLoadingData = ref(false);
/** 数据是否初始化完成 */
const isDataInit = ref(false);

/** 骨架屏 */
const templateTypeSkeleton = defineAsyncComponent(() => import('./template-type-skeleton.vue'));
/** 分类列表 */
const typeList = ref<RespCategory[]>([]);
/** 获取模板分类列表 */
const setTemplateTypeList = () => {
  isLoadingData.value = true;
  return reqTemplateTypeDataAsync()
    ?.then(({ data }) => {
      typeList.value = data;
    })
    .finally(() => {
      isLoadingData.value = false;
      isDataInit.value = true;
      resetTemplateTypeDataAsync();
    });
};

const nextZIndex = useZIndex().nextZIndex();
const rootStyle = computed(() => {
  return { zIndex: nextZIndex };
});

// #region 定制点击
const designUrl = 'https://f.kdocs.cn/w/KPcsuhBy/';
const onDesignClick = () => {
  dwOnDesignClick();
  designUrl && openInNewTab({ url: designUrl });
};
// #endregion

onMounted(() => {
  setTemplateTypeList();
});
</script>

<style lang="scss" scoped>
.template-type {
  &__root {
    // min-width: var(--lowcode-min-width);
    flex: none;
    position: sticky;
    // top: -1px;
    padding: 20px;
    // background-color: var(--lowcode-background-02);
    overflow: hidden;
  }

  &__main {
    margin-top: 20px;
  }

  &__header {
    display: flex;
    align-items: center;

    .label-left {
      display: inline-block;
      padding-left: 4px;
      height: 22px;
      font-size: 14px;
      font-weight: bold;
      color: var(--lowcode-text-03);
      line-height: 22px;
      flex: none;
    }

    .design {
      display: flex;
      align-items: center;

      &:hover {
        .label-design {
          color: var(--lowcode-theme-wps-02);
        }

        .icon-design {
          &:deep(path) {
            fill: var(--lowcode-theme-wps-02);
          }
          &:deep(rect) {
            stroke: var(--lowcode-theme-wps-02);
          }
        }
      }

      &:active {
        .label-design {
          color: var(--lowcode-theme-wps-03);
        }

        &:deep(path) {
          fill: var(--lowcode-theme-wps-03);
        }
        &:deep(rect) {
          stroke: var(--lowcode-theme-wps-03);
        }
      }
    }
    .label-design {
      cursor: pointer;
      height: 22px;
      font-size: 12px;
      color: var(--lowcode-theme-common-01);
      line-height: 22px;
      margin-left: 4px;
    }
    .icon-design {
      margin-left: 12px;
    }
  }
}
</style>
